import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-viz', {
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    height: '100%',
    width: '100%',
});

cssRule('.tb-viz iframe', {
    marginLeft: 'auto',
    marginRight: 'auto',
});

cssRule('.tb-viz.tb-device-viz-preview', {
    /* margin and transform are here because of the way some browsers calculate margin: auto leaves remnants behind on the screen 
     Far as I know, only happens in Safari out of our list of browsers */
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
    overflow: 'hidden',
    marginLeft: '50%',
    transform: 'translateX(-50%)',
});

cssRule('.tb-viz.tb-device-viz-preview iframe', {
    background: applyColor(DesignTokens.color.elevation.surface.default.default, '#fff'),
});

